import React from 'react'
import { Button, Modal } from 'react-bootstrap';
import { OrderDeleteRes, OrderDeleteTodo } from '../../redux/Slices/Orders/OrderDelete';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2'
import { useFormik } from 'formik';
import * as Yup from "yup";

export default function DeleteOrder(props) {
    const { orderData, deleteModal, setDeleteModal, bool, setBool } = props
    const handleClose = () => {
        setDeleteModal(false);
        values.reason = ''
    };
    const dispatch = useDispatch()

    const DeleteSchema = Yup.object({
        reason: Yup.string().required("Filed is Required"),
    });

    const initialValues = {
        reason: '',
        vpurchase_order_code: orderData?.vpurchase_order_code && orderData?.vpurchase_order_code,
        id:orderData?.id && orderData?.id

    };

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,
        validationSchema: DeleteSchema,
        enableReinitialize: true,

        onSubmit: (values, action) => {
            del_action()
            // console.log(values);
        }
    });

    const del_action = () => {

        Swal.fire({
            title: "Banner Delete",
            text: "Are You Sure Want To Delete This Banner ?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#121136',
            cancelButtonColor: '#EF3D50',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Delete'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(OrderDeleteTodo(values)).then(() => del_res())
            }

        })
    }

    const del_res = () => {
        if (OrderDeleteRes?.success) {
            setBool(!bool)
            Swal.fire(
                "Order",
                'Order Deleted Successfully',
                'success'
            )
            setDeleteModal(false);
        } else {
            toast.error(OrderDeleteRes?.message, { position: 'bottom-right' })
        }
    }


    return (
        <>
            <Modal show={deleteModal} onHide={handleClose} size="md" aria-labelledby="example-modal-sizes-title-md">
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-md">Delete Order</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='p-3'>
                        <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                            <div className='row'>

                                <div className='col-md-12'>
                                    <label htmlFor="">Reason</label>
                                    <input type="text" className="form-control form_input  "
                                        // placeholder="Username"
                                        name='reason'
                                        value={values.reason}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    {errors.reason && touched.reason ? (<span className='text-danger form_label' >{errors.reason}</span>) : null}
                                </div>
                            </div>

                            <div className='col-md-12 text-center mt-2'>
                                <Button type='submit' variant="" className='del_btn'>DELETE</Button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}
